import api from 'api/axiosInstance';
import { type SwanActivationStepIdType } from 'components/pages/Banks/BankingSignUp/ActivationFlow/constants/activationStepIds';

export interface ActivationStatusResponse {
  activationFurthestStepReached: SwanActivationStepIdType | null;
}

export interface UpdateActivationResponse {
  activationFurthestStepReached: SwanActivationStepIdType;
}

/**
 * Fetch the current activation status for the user
 * @returns Promise with activation status response
 */
export const getActivationStatus = (): Promise<ActivationStatusResponse> => {
  return api.get('/v2/accountable-banking/activation');
};

/**
 * Update the furthest activation step reached by the user
 * Only updates if it represents forward progress (equal to or later than current step)
 * Backend silently ignores updates to earlier steps
 * @param step - The activation step to update to
 * @returns Promise with updated activation response
 */
export const updateActivationStatus = (
  step: SwanActivationStepIdType,
): Promise<UpdateActivationResponse> => {
  return api.patch('/v2/accountable-banking/activation', {
    activationFurthestStepReached: step,
  });
};
